import React, {Component, useRef} from 'react'
//redux
import { connect } from "react-redux";
import { getUserInfoData } from "../User/store/actionCreators";
import { GET_USER_INFO_DATA } from "../User/store/actionTypes";
//样式
import {
    WagesCheckContainer
} from "./style";

//antd
import { Button, Search, Space,Toast,InfiniteScroll,Empty } from 'antd-mobile';
import { PullToRefresh } from 'antd-mobile-v2';
import { List,Card } from 'antd';

import $axios from "../../request";
import ImgVideoListItem from "../../components/ImgVideoListItem";
import CreationChartItem from "../../components/CreationChartItem";
import {isBlank} from "../../util/StringUtil";



class WagesRank extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            dataSource:[],
            pageNum:1,
            pageSize:10,
            refreshing: false,
            height: document.documentElement.clientHeight,
            listIndex: 0,
            activity:{},
            haveActivity:false,
            totalCount :0,
            hasMore:true
        }
    }

    componentDidMount() {
        //this.props._getUserInfoData();
       this.getChartData();
    }


    getChartData = () =>{

        const that = this;
        const {pageNum,pageSize,totalCount,refreshing} = that.state;

        const {activity} = this.props;
        if((!activity)||(isBlank(activity.id))||refreshing){
            console.log("无活动")
            return
        }
        if(totalCount!=0&&totalCount<=dataSource.length){
            return;
        }
        this.setState({'refreshing':true})
        let url= "/vote/creation/app/chart";
        let data = {
            activityId:activity.id,
            pageNum: pageNum,
            pageSize: pageSize
        }
        let dataSource = this.state.dataSource
        $axios.postRequest(url, data).then(res => {
                if(res && res.succeed){
                    let loading = false;
                    let pageNumTmp = pageNum;
                    if(res.totalCount>this.state.dataSource.length+res.data.length){
                        loading = true;
                        pageNumTmp = pageNumTmp+1;
                    }else{
                        loading = false
                    }

                    dataSource = pageNum===1?res.data: dataSource.concat(res.data);
                    that.setState({
                        pageNum: pageNumTmp,
                        dataSource: dataSource,
                        loading: loading,
                        refreshing: false,
                        hasMore:res.totalCount>dataSource.length,
                        totalCount:res.totalCount
                    });
                }
            }

        ).catch(function (error) {
            that.setState({
                loading: false,
                refreshing: true
            });
        });
    }


    render() {
        let { totalCount,height,hasMore,dataSource } = this.state
        let { userInfo,activity} = this.props;
        //console.log("dataSource",dataSource);


        return (
            <WagesCheckContainer>
                <div className="container">
                    {/*<PullToRefresh*/}
                    {/*    damping={60}*/}
                    {/*    style={{*/}
                    {/*        height: height,*/}
                    {/*        overflow: 'auto',*/}
                    {/*    }}*/}
                    {/*    direction={'up'}*/}
                    {/*    refreshing={refreshing}*/}
                    {/*    onRefresh={() => {*/}

                    {/*        if(totalCount===0||totalCount>dataSource.length){*/}
                    {/*            this.setState({ refreshing: true });*/}
                    {/*            this.getChartData()*/}
                    {/*        }*/}

                    {/*    }}*/}
                    {/*>*/}
                        <img src={activity?.rankBgImgPath?.toImg()} style={{width: "100%"}} alt="" />
                        <div>
                            {
                                dataSource.length ===0?
                                    <Empty description='暂无数据' />:
                                    <>
                                        <List
                                            className="marginTop0"
                                            loading={false}
                                            itemLayout="vertical"
                                            style={{whiteSpace: 'pre-wrap',padding:'0'}}
                                            dataSource={dataSource}
                                            rowKey={(item) => item.id}
                                            renderItem={item => (
                                                <List.Item style={{padding:'1'}}>
                                                    <CreationChartItem item={item} history={this.props.history}/>
                                                </List.Item>
                                            )}
                                        />
                                        <InfiniteScroll loadMore={()=> this.getChartData()} hasMore={hasMore} />
                                    </>

                            }


                            <div style={{height:'50px',width:'100vw'}}></div>

                        </div>
                    {/*</PullToRefresh>*/}

                </div>
            </WagesCheckContainer>
        )
    }
}

const mapState = state => {

    return {
        userInfo:state.getIn(['user', 'userInfo']),
        activity:state.getIn(['activity', 'activitySelect'])
    }

}
const mapDispatch = dispatch => {
    return {

        _getUserInfoData(data) {

            dispatch(getUserInfoData(data))
        }
    }
}

export default connect(mapState, mapDispatch)(WagesRank)
